import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './context/CartContext';
import Home from './components/Home';
import AdminLogin from './components/AdminLogin';
import Admin from './components/Admin';
import AuthCallback from './components/AuthCallback';
import ShopSuccess from './components/ShopSuccess';

function AppRoutes() {
  const location = useLocation();
  // Process Emergent OAuth callback FIRST (session_id arrives in the URL fragment)
  if (location.hash && location.hash.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/shop/success" element={<ShopSuccess />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </CartProvider>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
